import React, { useEffect, useState } from 'react';
import { Card } from 'reactstrap';
import * as Icon from 'react-feather';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { useDebouncedCallback } from 'use-debounce';

import AdminHeader from '../../../components/header/AdminHeader';
import CallexLoader from '../../../components/CallexLoader';
import Pagination from '../../../components/form/Pagination';
import DeleteConfirmationModal from '../../../components/Modals/DeleteConfirmationModal';

import {
  useWhatsappBotFlowList,
  whatsappBotFlowGet,
  whatsappBotFlowDelete
} from '../../../store/slices/tenantSlices/configurationSlice';
import { useUserDetails, useUserRolePermission } from '../../../store/slices/authSlice';
import { checkModulePermission } from '../../../utils/common';
import AddEditBotFlowModal from './AddEditBotFlowModal';

const WhatsappBotTemplates = () => {
  const dispatch = useDispatch();

  const user = useUserDetails();
  const whatsappBotFlowList = useWhatsappBotFlowList();
  const userRolePermission = useUserRolePermission();

  const [openAddModal, setOpenAddModal] = useState(false);
  const [editRecord, setEditRecord] = useState(null);
  const [isEdit, setIsEdit] = useState(null);
  const [isDeleteId, setIsDeleteId] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [filter, setFilter] = useState({
    page: 1,
    limit: 10,
    search: undefined
  });

  const fetchWhatsappTemplatesList = useDebouncedCallback(async () => {
    setIsLoading(true);
    try {
      const payload = { ...filter };
      await dispatch(whatsappBotFlowGet(payload)).unwrap();
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log('error', error);
    }
  }, 500);

  const deleteUser = async () => {
    try {
      const response = await dispatch(whatsappBotFlowDelete(isDeleteId)).unwrap();
      if (response) {
        toast.success('Record deleted successfully');
        if (whatsappBotFlowList?.data?.length === 1) {
          setFilter({ ...filter, page: filter?.page > 1 ? filter.page - 1 : 1 });
        } else {
          fetchWhatsappTemplatesList();
        }
        setIsDeleteId(null);
      }
    } catch (error) {
      console.log('error', error);
    }
  };

  useEffect(() => {
    fetchWhatsappTemplatesList();
  }, [filter]);

  return (
    <div>
      <AdminHeader
        title="Whatsapp Bot Flow"
        isExpandSearch
        isAdd
        onAddClick={() => setOpenAddModal(true)}
        addBtnName="Add Whatsapp Bot Flow"
        searchPlaceholder="Search Flow"
        search={filter.search}
        isAddDisabled={
          checkModulePermission('is_add', 'Whatsapp Bot Flow', userRolePermission)
            ? user?.allowUser === 0 || !user?.allowUser
              ? false
              : user?.allowUser <= whatsappBotFlowList?.total
            : false
        }
        handelSearch={(e) => setFilter({ ...filter, search: e.target.value })}
      />
      {isLoading ? (
        <Card
          className="p-0 d-flex justify-content-center align-items-center m-0"
          style={{ height: 'calc(100vh - 170px)' }}>
          <CallexLoader />
        </Card>
      ) : whatsappBotFlowList?.data?.length > 0 &&
        checkModulePermission('is_view', 'Whatsapp Bot Flow', userRolePermission) ? (
        <Card className="p-0 position-relative m-0">
          <div className="daily-report-table" style={{ height: 'calc(100vh - 210px)' }}>
            <table className="report-list-table">
              <thead>
                <tr>
                  <th>Store As</th>
                  <th className="text-center" style={{ width: '90px' }}>
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody>
                {whatsappBotFlowList?.data?.map((val, index) => {
                  return (
                    <tr key={index}>
                      <td>{val?.is_store}</td>
                      <td>
                        <div className="d-flex justify-content-around align-items-center">
                          <div
                            className={`cursor-pointer text-info ${
                              !checkModulePermission(
                                'is_edit',
                                'Whatsapp Bot Flow',
                                userRolePermission
                              )
                                ? 'callex-disabled'
                                : ''
                            }`}>
                            <Icon.Edit
                              size={16}
                              onClick={() => {
                                if (
                                  checkModulePermission(
                                    'is_edit',
                                    'Whatsapp Bot Flow',
                                    userRolePermission
                                  )
                                ) {
                                  setEditRecord(val);
                                  setIsEdit(true);
                                  setOpenAddModal(true);
                                }
                              }}
                            />
                          </div>
                          <div
                            className={`cursor-pointer text-danger  ${
                              !checkModulePermission(
                                'is_delete',
                                'Whatsapp Bot Flow',
                                userRolePermission
                              )
                                ? 'callex-disabled'
                                : ''
                            }`}>
                            <Icon.Trash
                              size={16}
                              onClick={() => {
                                if (
                                  checkModulePermission(
                                    'is_delete',
                                    'Whatsapp Bot Flow',
                                    userRolePermission
                                  )
                                ) {
                                  setIsDeleteId(val?.id);
                                }
                              }}
                            />
                          </div>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="position-absolute w-100" style={{ bottom: '-56px' }}>
            <Pagination
              totalCount={whatsappBotFlowList?.total}
              limit={whatsappBotFlowList?.limit}
              page={whatsappBotFlowList?.page}
              onLimitChange={(val) => {
                setFilter({ ...filter, page: 1, limit: val });
              }}
              onPageClick={(val) => setFilter({ ...filter, page: val })}
              lastPageClick={(val) => setFilter({ ...filter, page: val })}
              firstPageClick={(val) => setFilter({ ...filter, page: val })}
              onRefreshClick={() => fetchWhatsappTemplatesList()}
            />
          </div>
        </Card>
      ) : (
        <Card
          className="p-0 d-flex justify-content-center align-items-center no-data m-0"
          style={{ height: 'calc(100vh - 170px)' }}>
          {whatsappBotFlowList?.data?.length > 0 ? 'No preview available' : 'No data available'}
        </Card>
      )}
      <DeleteConfirmationModal
        isOpen={!!isDeleteId}
        onCloseClick={() => setIsDeleteId(null)}
        onDeleteClick={() => deleteUser()}
      />
      <AddEditBotFlowModal
        isOpen={openAddModal}
        onCloseClick={(apiCall = false) => {
          setOpenAddModal(false);
          setEditRecord(null);
          setIsEdit(false);
          if (apiCall) {
            fetchWhatsappTemplatesList();
          }
        }}
        editRecord={editRecord}
        isEdit={isEdit}
      />
    </div>
  );
};

export default WhatsappBotTemplates;
